<template>
  <div class="vr360-input-text"
       :class="{'vr360-input-text--error': showErrorMessage,
                'vr360-input-text--centered': isCentered }">

    <input class="vr360-text-reg"
           required=""
           placeholder=" "
           :type="type"
           :value="value"
           @change="emitChange"
           @input="emitInput">
    <label>
      <span class="vr360-head-h4 vr360-text-gray-2">{{ placeholder }}</span>
      <p class="vr360-text-caption">{{ errorMessage }}</p>
    </label>
  </div>
</template>

<script>
export default {
  name: "Input-text",
  props: {
    placeholder: {
      type: String,
      default: "placeholder"
    },
    type: {
      type: String,
      default: "text"
    },
    errorMessage: {
      type: String,
      default: "message"
    },
    value: {
      type: String
    },
    isCentered: {
      type: Boolean,
      default: false
    },
    showErrorMessage: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  methods: {
    emitInput(e) {
      this.$emit("input", e.target.value);
    },
    emitChange(e) {
      e.target.value = e.target.value.trim();
      this.$emit("change", e.target.value);
    }
  }
};
</script>
